class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
window.addEventListener("load", function () {
 
    

 const dndPromotion = window.libraryMainsite.promotion;
    let globalCount;
    async function animationRandom(prizeIndex) {
        // Remove class fall-down từ tất cả items trước khi chạy animation mới
        const grEffect = document.querySelector('#tanomg3q-ld-daile-vongquay .gr_effect');
        if (grEffect) {
            const items = grEffect.querySelectorAll('.gr_effect--item');
            items.forEach(item => {
                item.classList.remove('fall-down');
            });
        }

        const caymai = document.querySelector('#tanomg3q-ld-daile-vongquay .caymai');
        if (caymai) {
            caymai.classList.add('shake');
            setTimeout(() => {
                caymai.classList.remove('shake');
                
                // Sau khi cây rung xong, cho item tại vị trí prizeIndex rớt xuống
                if (grEffect) {
                    const items = grEffect.querySelectorAll('.gr_effect--item');
                    const targetIndex = parseInt(prizeIndex - 1); // prizeIndex + 1
                    console.log(targetIndex);
                    if (items[targetIndex]) {
                        items[targetIndex].classList.add('fall-down');
                    }
                }
            }, 1500);
        }
    };

    // Add click effect for action buttons to move group_meo
   

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 2500,
        },
        animResult: function (listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom(prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            // globalCount = 10;
            
        },
    })

    // Remove class fall-down khi click vào btn-close của popup_reward
    const popupReward = document.querySelector('#popup_reward');
    if (popupReward) {
        const btnClose = popupReward.querySelector('.btn-close');
        if (btnClose) {
            btnClose.addEventListener('click', function() {
                const grEffect = document.querySelector('#tanomg3q-ld-daile-vongquay .gr_effect');
                if (grEffect) {
                    const items = grEffect.querySelectorAll('.gr_effect--item');
                    items.forEach(item => {
                        item.classList.remove('fall-down');
                    });
                }
            });
        }
    }
   
});
